import { render, staticRenderFns } from "./AdminAcademicSubcategoriesNew.html?vue&type=template&id=b79e81e0&scoped=true&external"
import script from "./AdminAcademicSubcategoriesNew.vue?vue&type=script&lang=js"
export * from "./AdminAcademicSubcategoriesNew.vue?vue&type=script&lang=js"
import style0 from "./AdminAcademicSubcategoriesNew.scss?vue&type=style&index=0&id=b79e81e0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79e81e0",
  null
  
)

export default component.exports